// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VkNA","placeholdersHeader":"styles_placeholdersHeader__2cBIb","editorStyle":"styles_editorStyle__yugzC","placeholdersBox":"styles_placeholdersBox__3N6UX"};